import type { Messages } from './en';

export const tr: Messages = {
  'nav.clientHub': 'Müşteri Portalı',
  'nav.menu': 'Menü',
  'nav.home': 'Ana sayfa',
  'nav.products': 'Ürünler',
  'nav.liveCasino': 'Canlı Casino',
  'nav.slots': 'Slots',
  'nav.tableGames': 'Masa Oyunları',
  'nav.library': 'Kütüphane',
  'nav.roadmap': 'Yol haritası',
  'nav.assets': 'Materyaller',
  'nav.guidelines': 'Kılavuzlar',
  'nav.account': 'Hesap',
  'nav.signOut': 'Çıkış yap',
  'nav.categoriesAria': 'Oyun kategorileri',
  'nav.sectionsAria': 'Ana bölümler',
  'nav.brandAria': 'RichyPlay Müşteri Portalı',
  'nav.comingSoon': 'Çok yakında',
  'nav.soon': 'Yakında',

  'lang.label': 'Dil',
  'lang.select': 'Dil seçin',

  'category.live': 'Canlı',
  'category.slot': 'Slot',
  'category.instant': 'Anlık',
  'category.table': 'Masa',

  'status.planned': 'Planlandı',
  'status.in_progress': 'Devam ediyor',
  'status.shipped': 'Yayınlandı',
  'status.available': 'Kullanılabilir',
  'status.coming_soon': 'Çok yakında',
  'status.maintenance': 'Bakımda',

  'common.error': 'Bir sorun oluştu',
  'common.checkingSession': 'Oturum kontrol ediliyor…',
  'common.yes': 'Evet',
  'common.no': 'Hayır',
  'common.none': 'Yok',
  'common.active': 'Aktif',
  'common.inactive': 'Pasif',

  'home.eyebrow': 'Operatör portalı',
  'home.title': 'Müşteri Portalı',
  'home.lead':
    'RichyPlay portföyünü keşfedin — demoları başlatın, yol haritasını takip edin ve marka materyallerini tek bir çalışma alanından indirin.',
  'home.enterLibrary': 'Kütüphaneye gir',
  'home.viewRoadmap': 'Yol haritasını gör',
  'home.browse': 'Kategoriye göre keşfet',
  'home.openLibrary': 'Kütüphaneyi aç',

  'library.eyebrow': 'Oyun kütüphanesi',
  'library.title': 'Portföy',
  'library.liveTitle': 'Canlı Casino Portföyü',
  'library.slotTitle': 'Slot Portföyü',
  'library.liveLead': 'Bir canlı ürün seçin. Royal Blackjack ve Royal Roulette yayında; diğerleri yakında.',
  'liveFamily.roulette': 'Royal Roulette',
  'liveFamily.blackjack': 'Royal Blackjack',
  'liveFamily.autoRoulette': 'Auto Roulette',
  'liveFamily.thunderRoulette': 'Thunder Roulette',
  'liveFamily.infinityBlackjack': 'Infinity Blackjack',
  'liveFamily.baccarat': 'Baccarat',
  'liveFamily.poker': 'Poker',
  'liveFamily.dice': 'Dice',
  'liveFamily.showGames': 'Show Games',
  'library.lead': 'RichyPlay kataloğunda arama yapın ve filtreleyin. Demoları yeni sekmede açın.',
  'library.search': 'Oyun ara…',
  'library.statusFilterAria': 'Duruma göre filtrele',
  'library.statusAll': 'Tüm durumlar',
  'library.loading': 'Oyunlar yükleniyor…',
  'library.unavailableTitle': 'Kütüphane kullanılamıyor',
  'library.unavailableMessage': 'Oyun kütüphanesi yüklenemedi. Katalog geçici olarak kapalı olabilir.',
  'library.apiFailedMessage':
    'Katalog API’sine ulaşılamadı. Daha sonra tekrar deneyin veya destek ekibiyle iletişime geçin.',
  'library.emptyTitle': 'Oyun bulunamadı',
  'library.emptyMessage': 'Farklı bir arama veya kategori filtresi deneyin.',
  'library.viewGame': 'Oyunu gör',

  'game.loading': 'Oyun yükleniyor…',
  'game.notFound': 'Oyun bulunamadı.',
  'game.back': 'Geri',
  'game.breadcrumbAria': 'Sayfa yolu',
  'game.liveCasino': 'Canlı Casino',
  'game.slots': 'Slotlar',
  'game.demoFrameTitle': '{title} demosu',
  'game.startingDemo': 'Demo oturumu başlatılıyor…',
  'game.demoNotStarted': 'Demo oturumu başlatılamadı.',
  'game.demoBadge': 'Demo modu',
  'game.blockedMaintenance': 'Bu oyun bakımda.',
  'game.blockedComingSoon': 'Çok yakında — demo henüz yayınlanmadı.',
  'game.blockedNoDemo': 'Operatör kataloğu bu oyun için demo sürümü sunmuyor.',
  'game.currency': 'Para birimi',
  'game.language': 'Dil',
  'game.reloadDemo': 'Demoyu yeniden yükle',
  'game.startDemo': 'Demoyu başlat',
  'game.openNewTab': 'Yeni sekmede aç',
  'game.copyLink': 'Bağlantıyı kopyala',
  'game.copied': 'Kopyalandı',
  'game.demoFailedTitle': 'Demo başlatılamadı',
  'game.demoUrlMissing': 'Sunucu başlatma bağlantısı döndürmedi.',
  'game.demoFailed': 'Demo başlatılamadı.',
  'game.highlighted': 'Öne çıkan',
  'game.features': 'Oyun özellikleri',
  'game.keyFeatures': 'Öne çıkan özellikler',
  'liveTable.title': 'Mevcut masalar',
  'liveTable.totalResults': 'Toplam sonuç:',
  'liveTable.download': 'Masa verisini indir',
  'liveTable.gameId': 'Oyun kimliği',
  'liveTable.tableName': 'Masa adı',
  'liveTable.minLimit': 'Min masa limiti',
  'liveTable.maxLimit': 'Maks masa limiti',
  'liveTable.hours': 'Çalışma saatleri UTC',
  'liveTable.language': 'Yayın dili',
  'liveTable.releaseDate': 'Yayın tarihi',
  'liveTable.location': 'Konum',
  'game.betLevels': 'Bahis seviyeleri',
  'game.tableRules': 'Masa kuralları',
  'game.mathConfig': 'Matematik yapılandırması',
  'game.resources': 'Kaynaklar',
  'game.relatedAssets': 'İlgili materyaller',
  'game.releaseRoadmap': 'Yayın yol haritası',
  'game.integrationGuidelines': 'Entegrasyon kılavuzları',
  'game.information': 'Oyun bilgileri',
  'game.availableOn': 'Available On',
  'game.operatingLanguage': 'Operating Language',
  'game.uiLanguages': 'UI Languages',
  'game.platformDesktop': 'Masaüstü',
  'game.platformTablet': 'Tablet',
  'game.platformMobile': 'Mobil',
  'game.downloads': 'Downloads',
  'game.mediaPack': 'Media Pack',
  'game.gameData': 'Game Data (PDF)',
  'game.download': 'Download',
  'game.gameDataSoon': 'Oyun veri dosyası yakında eklenecek.',

  'spec.numericId': 'Numerik kimlik',
  'spec.minBetPerLine': 'Hat başına minimum bahis',
  'spec.minTotalBet': 'Minimum toplam bahis',
  'spec.maxTotalBet': 'Maksimum toplam bahis',
  'spec.maxTotalBetAnte': 'Ante ile maksimum toplam bahis',
  'spec.reels': 'Makara',
  'spec.rows': 'Satır',
  'spec.payType': 'Ödeme tipi',
  'spec.payLinesValue': '{count} hat',
  'spec.symbolPays': 'Sembol ödemesi',
  'spec.betMultiplier': 'Bahis çarpanı',
  'spec.maxMultiplierWin': 'Maksimum çarpan kazancı',
  'spec.maxExposure': 'Maksimum risk',
  'spec.bonusBuyX': 'Bonus satın alma X',
  'spec.anteBetX': 'Ante bahis X',
  'spec.rtps': 'RTP değerleri',
  'spec.hitFrequency': 'İsabet sıklığı',
  'spec.oneIn': '{value} oyunda 1',
  'spec.hasReplay': 'Tekrar oynatma',
  'spec.hasBuySpins': 'Spin satın alma',
  'spec.hasInstantBonus': 'Anında bonus',
  'spec.hasHyperplay': 'Hyperplay',
  'spec.hasAnteBet': 'Ante bahis',
  'spec.releaseDate': 'Yayın tarihi',
  'spec.symbol': 'Oyun sembolü',
  'spec.referenceId': 'Referans kimliği',
  'spec.provider': 'Sağlayıcı',
  'spec.product': 'Ürün',
  'spec.gameType': 'Oyun türü',
  'spec.category': 'Kategori',
  'spec.theme': 'Tema',
  'spec.technology': 'Teknoloji',
  'spec.rtp': 'RTP',
  'spec.volatility': 'Oynaklık',
  'spec.maxWin': 'Maksimum kazanç',
  'spec.paylines': 'Ödeme hatları',
  'spec.grid': 'Izgara',
  'spec.bonusFrequency': 'Bonus sıklığı',
  'spec.bonusFrequencyValue': '{value} oyunda 1',
  'spec.jackpot': 'Jackpot',
  'spec.betRange': 'Bahis aralığı',
  'spec.defaultBet': 'Varsayılan bahis',
  'spec.currency': 'Para birimi',
  'spec.languages': 'Diller',
  'spec.demoAvailable': 'Demo mevcut',
  'spec.tournaments': 'Turnuvalar',
  'spec.highlighted': 'Öne çıkan',
  'spec.status': 'Durum',
  'spec.version': 'Sürüm',
  'spec.lastUpdated': 'Son güncelleme',

  'roadmap.eyebrow': 'Ürün yol haritası',
  'roadmap.title': 'Sırada ne var',
  'roadmap.lead': 'Yaklaşan sürümleri ve yayınlanan oyunları kategoriye göre takip edin.',
  'roadmap.bannerAria': 'Yaklaşan yayınlar',
  'roadmap.soonTitle': 'Yakında',
  'roadmap.loading': 'Yol haritası yükleniyor…',
  'roadmap.error': 'Yol haritası öğeleri yüklenemedi.',
  'roadmap.emptyTitle': 'Yol haritası öğesi yok',
  'roadmap.emptyMessage': 'Bu kategori için henüz yayımlanmış bir kayıt yok.',
  'roadmap.itemCount': '{count} öğe',
  'roadmap.target': 'Hedef: {date}',
  'roadmap.viewInLibrary': 'Kütüphanede gör',

  'upcoming.title': 'Yaklaşan yayınlar',
  'upcoming.playDemo': 'Demo oyna',
  'upcoming.prev': 'Önceki yayınlar',
  'upcoming.next': 'Sonraki yayınlar',

  'assets.eyebrow': 'Marka materyalleri',
  'assets.title': 'Materyal paketleri',
  'assets.lead':
    'Logoları, ana görselleri ve pazarlama materyallerini indirin. Kullanım kuralları için {link} bölümüne bakın.',
  'assets.leadLink': 'materyal kılavuzları',
  'assets.loading': 'Materyaller yükleniyor…',
  'assets.error': 'Materyal paketleri yüklenemedi.',
  'assets.downloadFailed': 'İndirme başarısız.',
  'assets.emptyTitle': 'Henüz materyal yok',
  'assets.emptyForGame': 'Bu oyuna bağlı bir materyal paketi yok.',
  'assets.emptyGeneral': 'Materyal paketleri yayımlandığında burada görünecek.',
  'assets.pack': 'Paket',
  'assets.updated': '{date} tarihinde güncellendi',
  'assets.download': 'İndir',
  'assets.search': 'Oyun adına göre ara…',
  'assets.searchEmpty': 'Bu ada uyan oyun yok.',

  'guidelines.eyebrow': 'Dokümantasyon',
  'guidelines.title': 'Kılavuzlar',
  'guidelines.lead': 'Entegrasyon notları, materyal kullanımı ve operatör referansları.',
  'guidelines.all': 'Tümü',
  'guidelines.integration': 'Entegrasyon',
  'guidelines.assets': 'Materyaller',
  'guidelines.loading': 'Kılavuzlar yükleniyor…',
  'guidelines.error': 'Kılavuzlar yüklenemedi.',
  'guidelines.emptyTitle': 'Kılavuz yok',
  'guidelines.emptyMessage': 'Yayımlanan kılavuzlar burada görünecek.',
  'guidelines.index': 'Dizin',
  'guidelines.navAria': 'Kılavuz gezinmesi',
  'guidelines.articleLoading': 'Makale yükleniyor…',
  'guidelines.notFound': 'Kılavuz bulunamadı.',
  'guidelines.notFoundShort': 'Bulunamadı',
  'guidelines.updated': '{date} tarihinde güncellendi',
  'guidelines.external': 'İçerik harici olarak barındırılıyor.',
  'guidelines.openDocument': 'Belgeyi aç',
  'guidelines.typeGuide': 'Rehber',
  'guidelines.typeGuideline': 'Kılavuz',

  'account.eyebrow': 'Hesabınız',
  'account.title': 'Profil',
  'account.email': 'E-posta',
  'account.language': 'Arayüz dili',
  'account.recentActivity': 'Son etkinlikler',
  'account.loadingActivity': 'Etkinlikler yükleniyor…',
  'account.activityUnavailable': 'Son etkinlikler şu anda kullanılamıyor.',
  'account.noActivity': 'Kayıtlı son etkinlik yok.',

  'event.login': 'Giriş yapıldı',
  'event.logout': 'Çıkış yapıldı',
  'event.libraryView': 'Kütüphane görüntülendi',
  'event.gameView': 'Oyun görüntülendi',
  'event.demoLaunch': 'Demo başlatıldı',
  'event.demoLaunchFailed': 'Demo başlatılamadı',
  'event.assetDownload': 'Materyal indirildi',
  'event.guidelineView': 'Kılavuz görüntülendi',
  'event.roadmapView': 'Yol haritası görüntülendi',

  'auth.title': 'Müşteri Portalı',
  'auth.subtitle': 'Operatör bilgilerinizle giriş yapın',
  'auth.email': 'E-posta',
  'auth.password': 'Parola',
  'auth.rememberMe': 'Beni hatırla',
  'auth.signIn': 'Giriş yap',
  'auth.signInFailed': 'Giriş başarısız',
  'auth.signInError': 'Giriş yapılamadı. Bilgilerinizi kontrol edip tekrar deneyin.',
  'auth.forgotPassword': 'Parolanızı mı unuttunuz?',
  'auth.inviteOnly': 'Yalnızca davetle erişim. RichyPlay temsilcinizle iletişime geçin.',
  'auth.visitSiteAria': 'richyplay.live adresine git',

  'footer.navAria': 'Alt bilgi',
  'footer.tagline': 'RichyPlay slot ve canlı casino kataloğu için operatör portalı.',
  'footer.rights': 'Tüm hakları saklıdır.',
  'footer.legal': 'Lisanslı operatörler için davetle erişim. Yalnızca ticari kullanım içindir.',

  'forgot.eyebrow': 'Parola sıfırlama',
  'forgot.title': 'Parolamı unuttum',
  'forgot.requestSubtitle':
    'E-posta adresinizi girin; hesap varsa size bir doğrulama kodu göndereceğiz.',
  'forgot.sendCode': 'Kod gönder',
  'forgot.sendError': 'Sıfırlama kodu gönderilemedi.',
  'forgot.confirmSubtitle': 'E-postanızdaki kodu girin ve yeni bir parola belirleyin.',
  'forgot.code': 'Doğrulama kodu',
  'forgot.newPassword': 'Yeni parola',
  'forgot.update': 'Parolayı güncelle',
  'forgot.updateError': 'Parola sıfırlanamadı.',
  'forgot.doneSubtitle': 'Parolanız güncellendi. Artık giriş yapabilirsiniz.',
  'forgot.backToSignIn': 'Girişe dön',
};
